/**
 * Towing Operations Checklist
 * Before starting a tow
 * Regulatory: WBC3 Ch 26
 */

export const TOWING_CHECKLIST = {
  id: 'towing',
  name: 'Towing Operations',
  description: 'Before starting a tow',
  icon: 'Link',
  regulatory: 'WBC3 Ch 26',
  isCustomisable: true,
  items: [
    { id: 'tow_1', text: 'Tow assessed and suitable for conditions', required: true },
    { id: 'tow_2', text: 'Risk assessment completed', required: true },
    { id: 'tow_3', text: 'Towing gear inspected including emergency release', required: true },
    { id: 'tow_4', text: 'Communications established with tow', required: true },
    { id: 'tow_5', text: 'Crew briefed and at stations', required: true }
  ]
};
